import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Router } from './routes/router';
import { chooseEntryRoute } from './capability/webgl';

/**
 * Bootstrap — Phase 7 Wave 0 capability gate lives HERE, before any
 * React tree mounts. chooseEntryRoute() reads WebGL2 support + deviceMemory
 * + hover capability (see capability/webgl.ts) and returns either
 * { route: 'experience' } or { route: 'read'; reason: GateReason }.
 *
 * If the visitor landed on `/` AND the gate says 'read', rewrite the URL
 * (via history.replaceState — no reload, no extra request) to
 * `/read?reason=<code>` so the BrowserRouter inside <Router /> resolves to
 * ReadTheTour with the correct reason banner.
 *
 * Deep-links to /about, /credits, /sources, or /read itself are NOT
 * hijacked — a visitor intentionally navigating to /about on a
 * WebGL-incapable browser should see the About page, not be dumped into
 * /read.
 */
const gate = chooseEntryRoute();
if (gate.route === 'read' && window.location.pathname === '/') {
  window.history.replaceState(
    null,
    '',
    `/read?reason=${encodeURIComponent(gate.reason)}`
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router />
  </StrictMode>
);
